import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Link as RouterLink } from 'react-router-dom'
import { ROUTES } from '../constants'
import { readiness } from './MerchantStatus'
import { Banner } from './SetupUi'
import AddPickupDrawer from './AddPickupDrawer'

/**
 * What the merchant still needs outside these steps before PTL orders can be booked: KYC approval (merchant details
 * page) and a pickup location (added here, AddPickupDrawer). Nothing when both are there. These do not block the steps;
 * booking refuses the order until they are done. onStep = shown on a step page (says the steps can go on meanwhile);
 * onChanged() reloads the merchant after a pickup location is added.
 */
export default function BookingReadinessBanner({ merchant, onStep = true, onChanged }) {
  const [adding, setAdding] = useState(false)
  const r = readiness(merchant)
  if (r.kyc.ok && r.pickup.ok) return null
  const needs = [!r.kyc.ok && `KYC approval (now: ${r.kyc.label})`, !r.pickup.ok && 'a pickup location'].filter(Boolean)
  return (
    <Banner tone='warn'>
      {merchant.name} cannot book PTL orders yet: it needs {needs.join(' and ')}.
      {onStep ? ' You can carry on with these steps meanwhile.' : ''}
      {/* Actions under the text, so a narrow screen keeps the sentence readable. */}
      <Box component='span' sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.75, ml: -1 }}>
        {!r.kyc.ok && (
          <Button size='small' component={RouterLink} to={ROUTES.merchantKyc(merchant.id)} target='_blank' rel='noopener'
            endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />} sx={LINK_SX}>
            Open KYC in merchant details
          </Button>
        )}
        {!r.pickup.ok && (
          <Button size='small' onClick={() => setAdding(true)} startIcon={<AddLocationAltOutlinedIcon sx={{ fontSize: 16 }} />} sx={LINK_SX}>
            Add pickup location
          </Button>
        )}
      </Box>
      <AddPickupDrawer merchant={merchant} open={adding} onClose={() => setAdding(false)} onSaved={() => onChanged && onChanged()} />
    </Banner>
  )
}

const LINK_SX = { textTransform: 'none', fontWeight: 600, whiteSpace: 'nowrap', minHeight: 32 }
